/* eslint-disable react/jsx-no-target-blank */
import Menu from "pages/menuMain/menu";
import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import $ from "jquery";
import { RewardHistoryView } from "services/Api/Module/Reward";
import helper from "services/helper";

const RewardHistoryDetail = () => {
  const [rewardHistoryData, setRewardHistoryData] = useState({});
  const navigate = useNavigate();

  const stateProfile = useSelector((state) => state.profile.dataUser);
  const customerId = stateProfile.id;

  let [searchParams, setSearchParams] = useSearchParams();
  const rewardHistoryId = searchParams.get("id");

  const getRewardHistoryView = async () => {
    let _return = {
      status: false,
      result: {},
      rowCount: 0,
    };

    try {
      const { data } = await RewardHistoryView({
        rewardHistoryId: rewardHistoryId,
        params: { customer: customerId },
      });
      if (data.resultCode === "20000") {
        const resData = data.resultData;
        const rowCount = data.rowCount;

        _return.status = true;
        _return.result = resData;
        _return.rowCount = rowCount;
      }
    } catch (e) {
      console.log(e);
      return _return;
    }
    return _return;
  };

  const fetchRewardHistoryView = async () => {
    try {
      const resData = await getRewardHistoryView();
      setRewardHistoryData(resData.result);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchRewardHistoryView();
  }, [stateProfile]);

  return (
    <div>
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>

      <div id="pageHistory-Reward-Details">
        {/* <!-- Content Page --> */}
        <main>
          <div className="wrapContent">
            <section id="pTitlePage">
              <div className="bTitlePage">
                <a
                  className="btnIconBack"
                  onClick={() => navigate("/history-reward")}
                ></a>
                <h2>ประวัติการแลก Reward</h2>
              </div>
            </section>
            <section id="pContent">
              <h1>รายละเอียด</h1>
              <div className="bRewardMain bCard">
                <div className="bTitle">
                  <h2>ของรางวัล Rewards</h2>
                  {/* <!-- <div className="tStatus" data-status="pending">รอจัดส่ง</div> --> */}
                  {/* <div className="tStatus" data-status="shipped">จัดส่งแล้ว</div> */}
                  {rewardHistoryData.trackingStatus ? (
                    <div className="tStatus" data-status="shipped">
                      จัดส่งแล้ว
                    </div>
                  ) : (
                    <div className="tStatus" data-status="pending">
                      รอจัดส่ง
                    </div>
                  )}
                </div>
                <div className="bRewardDetails">
                  <div className="bPoint">
                    <h2>{rewardHistoryData.rewardTitle}</h2>
                    <div>
                      <span>ใช้ Point แลก</span>
                      <p>
                        {helper.FN.toNumberWithCommas(
                          rewardHistoryData.pointToRedeem
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="bProductImg">
                    <div className="bPic">
                      <img
                        src={
                          rewardHistoryData.rewardImg
                            ? rewardHistoryData.rewardImg
                            : "https://dummyimage.com/200x200/fff/000"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="bTotalPoint">
                    {/* <p>จำนวนสิทธิ์ที่ลุ้น : <span>12</span></p> */}
                    <div className="bPoint">
                      <p>
                        คุณใช้
                        <span>
                          {helper.FN.toNumberWithCommas(
                            rewardHistoryData.redeemUsedPoint
                          )}
                        </span>
                        ในการแลก
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bShipped bCard">
                <div className="bTrackingMain">
                  <div className="bDetails">
                    <div className="bTransport">
                      ขนส่งโดย:
                      {/* <!-- ถ้ายังไม่ส่งของให้เอารูปออก --> */}
                      {rewardHistoryData.trackingStatus == 1 ? (
                        <img
                          src="assets/img/ci/transport/logo-flash.svg"
                          alt=""
                        />
                      ) : (
                        <span>รอการจัดส่ง</span>
                      )}
                    </div>
                    <div className="bTrackingNumber">
                      หมายเลขพัสดุ
                      {
                        // rewardHistoryData.trackingStatus == 1 &&
                        rewardHistoryData.trackingNumber ? (
                          <p>{rewardHistoryData.trackingNumber}</p>
                        ) : (
                          <span>รอการจัดส่ง</span>
                        )
                      }
                    </div>
                    <div className="bCondition">
                      สามารถตรวจสอบสถานะการจัดส่งได้
                      <br />
                      โดยการกดที่หมายเลขพัสดุ
                    </div>
                  </div>
                  <div className="bBtn">
                    {
                      // rewardHistoryData.trackingStatus == 1
                      rewardHistoryData.trackingNumber ? (
                        <a
                          href={`https://www.flashexpress.co.th/fle/tracking?se=${rewardHistoryData.trackingNumber}`}
                          className="btnTracking"
                          target="_blank"
                        >
                          เช็กพัสดุ
                        </a>
                      ) : (
                        // ? <a href={`${rewardHistoryData.trackingLink}`} className="btnTracking" target="_blank">เช็กพัสดุ</a>
                        <a className="btnTracking">เช็คพัสดุ</a>
                      )
                    }
                  </div>
                </div>
                <div className="bCodeDate">
                  <div className="bRow">
                    <p>
                      <span>รหัส:</span>
                      {rewardHistoryData.orderCode}
                    </p>
                    <p>
                      <span>วันที่/เวลาแลกของรางวัล:</span>
                      {/* 20/07/2566 12:21:01 น.<br/> */}
                      {helper.TIME.toShortDateTimeNormalTH(
                        rewardHistoryData.createdOn
                      )}
                    </p>
                  </div>
                </div>
                <div className="bAddress">
                  <div className="bRow">
                    <p>
                      <span>ชื่อผู้แลก:</span>
                      {rewardHistoryData.firstName} {rewardHistoryData.lastName}
                    </p>
                    <p>
                      <span>เบอร์โทรศัพท์:</span>
                      {helper.FORMAT.TEL(rewardHistoryData.mobileNo)}
                    </p>
                  </div>
                  <div className="bRow">
                    <p>
                      <span>สถานที่จัดส่ง:</span>
                      {/* 12/29 หมู่บ้านไชยลดา ถนนราษฎรพัฒนา แขวงราษฏรพัฒนา เขตสะพานสูง กรุงเทพมหานคร 10230  */}
                      {rewardHistoryData.address}{" "}
                      {rewardHistoryData.subDistrictName}{" "}
                      {rewardHistoryData.districtName}{" "}
                      {rewardHistoryData.provinceName}{" "}
                      {rewardHistoryData.postcode}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bBtn">
                <a onClick={() => navigate("/history-reward")} className="btn">
                  ย้อนกลับ
                </a>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default RewardHistoryDetail;
